import { useMutation, useQueryClient } from '@tanstack/react-query';
import { publicCertificationControllerSaveCertifierDetailsMutation } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import type { WitnessDetails } from './usePublicSigningInfo';

/**
 * DC-825: saves a KYC certifier's details, then refreshes the signing info so the page moves on
 * to the certification wording. The form's occupation field holds their professional capacity.
 */
export const useSaveCertifierDetails = (token: string) => {
	const queryClient = useQueryClient();
	const mutation = useMutation({
		...publicCertificationControllerSaveCertifierDetailsMutation(),
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: ['public-signing-info', token] });
		},
	});

	return {
		mutate: (details: WitnessDetails, options?: Parameters<typeof mutation.mutate>[1]) =>
			mutation.mutate(
				{
					body: {
						token,
						fullName: details.fullName,
						address: details.address,
						professionalCapacity: details.occupation,
					},
				},
				options
			),
		isPending: mutation.isPending,
		isError: mutation.isError,
	};
};
